import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_licenseplates_by_lookupcode_and_warehouseIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { warehouseId: number, lookupcode: string }): 
  Promise<{ result: { Id?: number, LocationId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { warehouseId: number, lookupcode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LocationId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { warehouseId: number, lookupcode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LocationId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.warehouseId)) {
      $missingRequiredInParams.push('\'warehouseId\'');
    }
    if (isNil($inParams.lookupcode)) {
      $missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      warehouseId: number, lookupcode: string    }) {
        if(isNil($inParams.warehouseId)) {
          return true; 
        }
        if(isNil($inParams.lookupcode)) {
          return true; 
        }
      return false;
    }
}
